var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.addOrEditType === "add" ? "新建固件版本" : "编辑固件版本",
        visible: _vm.firmwareVersionVisible,
        width: "628px",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.firmwareVersionVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { rules: _vm.rules, model: _vm.form, "label-width": "160px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "固件名称", prop: "name" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [_vm._v("固件名称")]),
                              _vm._v(" \n            "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "仅用于管理固件，不对外显示",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-wenhao",
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm.addOrEditType === "add" &&
                      _vm.pageType === "firmwareDetails"
                        ? _c("el-input", {
                            attrs: {
                              maxlength: "32",
                              "show-word-limit": "",
                              placeholder: "请输入固件名称",
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.form.name))]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "固件版本", prop: "version" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [_vm._v("固件版本")]),
                              _vm._v(" \n            "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: { placement: "top" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "content",
                                      fn: function () {
                                        return [
                                          _c("p", [
                                            _vm._v(
                                              "①版本号根据 小数点(.) 分割，转成int 数组，依次顺序比较数组里的 int数字，数字大则版本号大;"
                                            ),
                                          ]),
                                          _c("p", [
                                            _vm._v(
                                              "②若数组的int数字均相同，则比较两个数组的长度，长度长的版本号大长度也相等的则两个版本号相等;"
                                            ),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-wenhao",
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm.addOrEditType === "add"
                        ? _c("el-input", {
                            attrs: {
                              maxlength: "10",
                              "show-word-limit": "",
                              placeholder: "版本号格式为xx.xx.xx，如1.0.0",
                            },
                            model: {
                              value: _vm.form.version,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "version", $$v)
                              },
                              expression: "form.version",
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.form.version))]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "关键版本", prop: "criticalVersionFlag" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [_vm._v("关键版本")]),
                              _vm._v(" \n            "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "内容同原创建新固件中“关键版本为不可越过的版本，即当设定某个版本为关键版本后，即使发布了新的固件老固件也必须升级为关键版本，才可继续升级为最新版本",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-wenhao",
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.criticalVersionFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "criticalVersionFlag", $$v)
                            },
                            expression: "form.criticalVersionFlag",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "固件包", prop: "package" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [_vm._v("固件包")]),
                              _vm._v(" \n            "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: { placement: "top" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "content",
                                      fn: function () {
                                        return [
                                          _c("p", [
                                            _vm._v(
                                              "一般用于固件升级（OTA）的固件文件"
                                            ),
                                          ]),
                                          _c("p", [
                                            _vm._v(
                                              "全量升级类型的升级包上传不需要填写支持版本，其他类的升级包请务必填写支持设备版本"
                                            ),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-wenhao",
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "firmwareUpload",
                          staticClass: "upload-demo",
                          attrs: {
                            action: "#",
                            "before-upload": _vm.beforeUpload,
                            "on-error": _vm.uploadError,
                            "on-exceed": _vm.handleExceed,
                            "http-request": _vm.onHttpRequest,
                            limit: 1,
                            disabled: _vm.isUploading,
                            "file-list": _vm.fileList,
                            "show-file-list": false,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                icon: "el-icon-plus",
                                loading: _vm.isUploading,
                                disabled: _vm.isUploading,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.uploadBtnText) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.isUploading
                        ? _c("div", { staticClass: "upload-status-line" }, [
                            _c("div", { staticClass: "upload-status-text" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "upload-package-name",
                                  attrs: { title: _vm.uploadFileName },
                                },
                                [_vm._v("包名：" + _vm._s(_vm.uploadFileName))]
                              ),
                              _vm.statusText
                                ? _c(
                                    "span",
                                    { staticClass: "upload-status-step" },
                                    [_vm._v(_vm._s(_vm.statusText))]
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              { staticClass: "upload-progress-row" },
                              [
                                _c("el-progress", {
                                  staticClass: "upload-progress-bar",
                                  attrs: {
                                    percentage: _vm.uploadPercentage,
                                    "stroke-width": 6,
                                    "show-text": false,
                                    color: "#275fe8",
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "upload-progress-percent" },
                                  [_vm._v(_vm._s(_vm.uploadPercentage) + "%")]
                                ),
                                _c("i", {
                                  staticClass:
                                    "el-icon-close upload-cancel-icon",
                                  attrs: { title: "取消上传" },
                                  on: { click: _vm.cancelUpload },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm.uploadFileName
                        ? _c("div", { staticClass: "upload-result-line" }, [
                            _c(
                              "span",
                              {
                                staticClass: "upload-result-name",
                                attrs: { title: _vm.uploadFileName },
                              },
                              [_vm._v("包名：" + _vm._s(_vm.uploadFileName))]
                            ),
                            _vm.uploadResult === "success"
                              ? _c("i", {
                                  staticClass:
                                    "el-icon-success upload-result-icon success",
                                })
                              : _vm.uploadResult === "error"
                              ? _c("i", {
                                  staticClass:
                                    "el-icon-error upload-result-icon error",
                                })
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "版本说明", prop: "description" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "200",
                          "show-word-limit": "",
                          placeholder: "请输入适当说明信息",
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "", prop: "isListed" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [_vm._v("是否上架")]),
                              _vm._v(" \n            "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "上架操作后，才能进行固件升级和产品发布。选择上架则默认使用范围为“不限范围”",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-wenhao",
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.isListed,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isListed", $$v)
                            },
                            expression: "form.isListed",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "14" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "14", disabled: _vm.isUploading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }